// 订单api

import { baseRequest, fileUploadRequest, saveDownloadFile } from './base'

/**
 * @desc 订单列表
 */
function getFinOrderList(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/finOrder/'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 查询学校的名称
 */
function searchSchoolName(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaSchool/selectSearch'
  return baseRequest(tempUrl, 'get', params)
}
/**
 * @desc 查询课程方的名称
 */
function searchInstitutionName(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaInstitution/selectSearch'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 查询班级的名称
 */
function searchClassName(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaClass/selectSearch'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 导出订单
 */
function exportOrder(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  return fileUploadRequest(`/api/pcWeb/finOrder/exportOrder`, params)
}

/**
 * @desc 查询课程的名称
 */
function searchCourseName(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = 'api/pcWeb/teaCourse/selectSearchAll'
  return baseRequest(tempUrl, 'get', params)
}

// 支付设置V2获取支付列表
function getPayConfigListV2(params) {
  let tempUrl = '/pay/paySetting/v2/getPayConfigList'
  return baseRequest(tempUrl, 'get', params)
}

// 支付设置V2  启用按钮
function payV2Enabled(params) {
  let tempUrl = '/pay/paySetting/v2/updateEnabled'
  return baseRequest(tempUrl, 'post', params)
}

// 支付设置V2  获取收款对接渠道列表
function getPayChannel(params) {
  let tempUrl = '/pay/paySetting/v2/getPayChannel'
  return baseRequest(tempUrl, 'get', params)
}

// 支付设置V2  获取程序对接配置
function getPayConfigEcho(params) {
  let tempUrl = '/pay/paySetting/v2/getPayConfigEcho'
  return baseRequest(tempUrl, 'get', params)
}

// 支付设置V2  新增保存
function addPaymentSettings(params) {
  let tempUrl = '/pay/paySetting/v2/addPaymentSettings'
  return baseRequest(tempUrl, 'post', params)
}

// 支付设置V2  数据回显
function getPayConfigCurrent(params) {
  let tempUrl = '/pay/paySetting/V2/getPayConfigCurrent'
  return baseRequest(tempUrl, 'get', params)
}

// 支付设置V2  对接配置数据回显接口
function getConfigJson(params) {
  let tempUrl = '/pay/paySetting/V2/getConfigJson'
  return baseRequest(tempUrl, 'get', params)
}

// 支付设置V2  修改保存
function updatePayConfig(params) {
  let tempUrl = '/pay/paySetting/v2/updatePayConfig'
  return baseRequest(tempUrl, 'post', params)
}

// 支付设置V2  测试下单
function testDoPay(params) {
  let tempUrl = '/pay/paySetting/v2/testDoPay'
  return baseRequest(tempUrl, 'post', params, true, false)
}

// 费用管理--获取学期和费用类型列表
function selectTermAndExpenseType() {
  let tempUrl = 'api/pcWeb/accountExpenseApplication/selectTermAndExpenseType'
  return baseRequest(tempUrl, 'get')
}
// 费用管理--费用管理列表数据
function expenseApplication(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = 'api/pcWeb/accountExpenseApplication/query'
  return baseRequest(tempUrl, 'get', params)
}

// 费用管理--批量提交
function batchSubmitRequest(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = 'api/pcWeb/accountExpenseApplication/batchSubmit'
  return baseRequest(tempUrl, 'post', params)
}
// 费用管理--批量删除
function deleteExpenseRequest(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = 'api/pcWeb/accountExpenseApplication/deleteExpense'
  return baseRequest(tempUrl, 'post', params)
}
// 费用管理--查看详情
function expenseDetails(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = 'api/pcWeb/accountExpenseApplication/expenseDetails'
  return baseRequest(tempUrl, 'get', params)
}
// 费用管理--保存按钮
function saveOrUpdate(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = 'api/pcWeb/accountExpenseApplication/saveOrUpdate'
  return baseRequest(tempUrl, 'post', params)
}
// 费用管理--提交申请按钮
function saveAndSubmit(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = 'api/pcWeb/accountExpenseApplication/saveAndSubmit'
  return baseRequest(tempUrl, 'post', params)
}
// 费用管理--文件下载
function getFile(id) {
  baseRequest(
    `api/pcWeb/accountExpenseApplication/getFile/${id}`,
    'get',
    null,
    {
      responseType: 'arraybuffer',
    }
  ).then(saveDownloadFile)
}

// 确认银行收款凭证
export const confirmBankTransfers = (params) => {
  return baseRequest('/api/order/confirmBankTransfers', 'post', params);
}
// 查看银行收款凭证详情
export const getPayment = (id) => {
  return baseRequest(`api/pcWeb/finOrder/getFinPayment/${id}`, 'get');
}
// 查看银行收款凭证详情
export const getOrderPayment = (id) => {
  return baseRequest(`api/pcWeb/finOrder/getFinPaymentByOrderId/${id}`, 'get');
}


export default {
  getFinOrderList: getFinOrderList,
  searchSchoolName: searchSchoolName,
  searchInstitutionName: searchInstitutionName,
  searchClassName: searchClassName,
  exportOrder: exportOrder,
  searchCourseName,
  getPayConfigListV2,
  payV2Enabled,
  getPayChannel,
  getPayConfigEcho,
  addPaymentSettings,
  getPayConfigCurrent,
  getConfigJson,
  updatePayConfig,
  testDoPay,
  selectTermAndExpenseType,
  expenseApplication,
  batchSubmitRequest,
  deleteExpenseRequest,
  expenseDetails,
  saveOrUpdate,
  saveAndSubmit,
  getFile,
  confirmBankTransfers,
  getPayment,
  getOrderPayment
}
